/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

function start() {
    const rootElement = document.getElementById("root");
    if (!rootElement) {
        console.error("Root element not found!");
        return;
    }
    
    try {
        const root = createRoot(rootElement);
        root.render(<App />);
    } catch (error) {
        console.error("Failed to render app:", error);
        rootElement.innerHTML = "<div style='padding: 20px; color: red;'>Failed to load application. Please check the console for errors.</div>";
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
} else {
    start();
}
